// Empreinte du contenu d'un bon de commande : sert à savoir si le panier a été modifié depuis
// l'ouverture / l'enregistrement du bon (bouton « Mettre à jour » seulement dans ce cas).
export default function orderFormSignature({ products, bundles, discount, note, clientId }) {
  const sorted = (items, key) => Object.values(items || {})
    .map(item => [String(item[key]), Number(item.number) || 0, Number(item.remise) || 0, Number(item.price_offset) || 0])
    .sort((a, b) => a[0].localeCompare(b[0]))

  return JSON.stringify([
    sorted(products, 'product_id'),
    sorted(bundles, 'bundle_id'),
    Number(discount) || 0,
    note || '',
    clientId || null,
  ])
}
